import { Link, SxProps } from '@mui/material';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';

interface FindReplacementLinkProps {
    sx?: SxProps;
    dataTestClass?: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    inline?: boolean;
}

export const FindReplacementLink = ({
    sx,
    dataTestClass,
    onClick,
    inline = false,
}: FindReplacementLinkProps) => {
    const { t } = useTranslation();
    const { navigateToMarketplace } = useMarketplaceNavigation();

    return (
        <Link
            data-testid="find-replacement-link"
            data-testclass={dataTestClass}
            component="button"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                    onClick(e);
                    return;
                }
                navigateToMarketplace({ clearSearch: true });
            }}
            variant={inline ? 'caption' : 'subtitle2'}
            sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                ...(inline
                    ? {
                          '&:hover': {
                              textDecoration: 'underline',
                          },
                      }
                    : {
                          display: 'inline-flex',
                          alignItems: 'center',
                          height: '32px',
                          minHeight: '32px',
                          boxSizing: 'border-box',
                          padding: '0 10px',
                          borderRadius: '4px',
                          fontSize: '1.3rem',
                          fontWeight: 500,
                          lineHeight: '2rem',
                          '&:hover': {
                              backgroundColor: '#E8EEF6',
                              textDecoration: 'none',
                          },
                      }),
                ...sx,
            }}
        >
            {t('Find replacement')}
        </Link>
    );
};
